import React, { useState } from 'react'
import InputCustom from '../../../../atoms/input/InputCustom'
import ButtonCustom from '../../../../atoms/button/ButtonCustom'
import styles from '../index.module.scss'

const PhotographyModal = () => {
	const [sessions, setSessions] = useState([
		{ sessionName: '', sessionLocation: '' },
	])

	const handleAddSession = () => {
		if (sessions.length < 6) {
			setSessions([...sessions, { sessionName: '', sessionLocation: '' }])
		}
	}

	const handleInputChange = (index, field, value) => {
		const newSessions = [...sessions]
		newSessions[index][field] = value
		setSessions(newSessions)
	}

	const handleRemoveSession = (index) => {
		if (index !== 0) {
			const newSessions = sessions.filter((_, i) => i !== index)
			setSessions(newSessions)
		}
	}

	return (
		<>
			<div className={styles.header}>
				<h3>Photography Timeline</h3>
				<ButtonCustom
					onClick={handleAddSession}
					disabled={sessions.length >= 10}
				>
					+ Add Session
				</ButtonCustom>
			</div>

			{sessions.map((session, index) => (
				<div className={styles.photographyTimelineRow} key={index}>
					<div className={styles.formField}>
						<InputCustom
							type="text"
							name={`Session name ${index}`}
							id={`Session name ${index}`}
							placeholder="Session name"
							value={session.sessionName}
							onChange={(e) =>
								handleInputChange(
									index,
									'sessionName',
									e.target.value
								)
							}
						/>
					</div>
					<div className={styles.formField}>
						<InputCustom
							type="text"
							name={`Session location ${index}`}
							id={`Session location ${index}`}
							placeholder="Session location"
							value={session.sessionLocation}
							onChange={(e) =>
								handleInputChange(
									index,
									'sessionLocation',
									e.target.value
								)
							}
						/>
					</div>
					<div className={styles.deleteRowBtn}>
						<ButtonCustom
							variant="outlined"
							size="lg"
							onClick={() => handleRemoveSession(index)}
							disabled={index === 0} // Disable delete for the first row
						>
							<img src="/images/trash.svg" alt="delete" />
						</ButtonCustom>
					</div>
				</div>
			))}
		</>
	)
}

export default PhotographyModal
